import React from "react";

const ScreenRocket = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 192 192" {...props}>
    <defs>
      <linearGradient id="a" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#8ad3fe" />
        <stop offset="1" stopColor="#54a5ff" />
      </linearGradient>
      <linearGradient id="b" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#d3e6f5" />
        <stop offset="1" stopColor="#f0f7fc" />
      </linearGradient>
      <linearGradient id="c" x1="0.123" y1="1.215" x2="0.877" y2="-0.105" />
      <linearGradient id="d" x1="0.5" y1="1" x2="0.5" gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#fe9661" />
        <stop offset="1" stopColor="#ffb369" />
      </linearGradient>
    </defs>
    <path
      d="M196,38V51.714a20.571,20.571,0,0,1-20.571,20.571H24.571A20.571,20.571,0,0,1,4,51.714V38Z"
      transform="translate(-4 78.571)"
      fill="url(#a)"
    />
    <path
      d="M92.27,89.143H21.71L35.836,48H78.144Z"
      transform="translate(39.01 102.857)"
      fill="#4795ea"
    />
    <path
      d="M40.286,48.857H33.429a3.429,3.429,0,0,1,0-6.857h6.857a3.429,3.429,0,0,1,0,6.857Z"
      transform="translate(59.143 88.286)"
      fill="url(#b)"
    />
    <path
      d="M196,26.571v89.143H4V26.571A20.571,20.571,0,0,1,24.571,6H175.429A20.571,20.571,0,0,1,196,26.571Z"
      transform="translate(-4 0.857)"
      fill="url(#b)"
    />
    <path
      d="M28,29H55.429v6.857a6.857,6.857,0,0,1-6.857,6.857H34.857A6.857,6.857,0,0,1,28,35.857Z"
      transform="translate(54.286 56.714)"
      fill="#eb7f58"
    />
    <path
      d="M78.871,45.143V81.52A11.006,11.006,0,0,1,68.585,93.143H34.3A11.006,11.006,0,0,1,24.013,81.52V45.143a32.983,32.983,0,0,1,9.36-23.349L51.442,4,69.511,21.863A32.983,32.983,0,0,1,78.871,45.143Z"
      transform="translate(44.558 -4)"
      fill="url(#d)"
    />
    <path
      d="M37.566,20V44H21.828a3.429,3.429,0,0,1-2.4-5.863Z"
      transform="translate(31.006 34.857)"
      fill="#fe9661"
    />
    <path
      d="M56.457,46.429H40V19L59.029,40.737a3.429,3.429,0,0,1-2.571,5.691Z"
      transform="translate(83.429 32.429)"
      fill="#fe9661"
    />
    <circle
      cx="10.286"
      cy="10.286"
      r="10.286"
      transform="translate(85.714 51.429)"
      fill="#d7e9f7"
    />
    <circle cx="6.857" cy="6.857" r="6.857" transform="translate(89.143 20.571)" fill="url(#b)" />
    <path
      d="M104.714,64.857H22.429a3.429,3.429,0,0,1,0-6.857h82.286a3.429,3.429,0,0,1,0,6.857Z"
      transform="translate(32.429 127.143)"
      fill="#0668cb"
    />
  </svg>
);

export default ScreenRocket;
